import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import FormSwitch from '../../../../../../../../components/FormSwitch';

import * as types from '../../reducer/constants';
import { getNextRefillType } from './helper';
import { getNextRefillCheck } from '../../components/FieldsRefill/helper';
import { getProviderRefillDays } from '../RefillDays/helper';

const FieldRefillSwitch = ({ form, providerForm, dispatchServiceData }) => {
  const {
    provider_service_id,
    refill: { refill_type },
  } = form;
  const { config } = useSelector((state) => state.services);
  const { default_refill_days } = config;
  const selectedValue = !!refill_type;
  const providerRefillDays = getProviderRefillDays(provider_service_id, providerForm);

  const onChange = () => {
    const value = !selectedValue;
    const defaultRefillDays = default_refill_days || 2;
    if (value) {
      const refillType = getNextRefillType(form, providerForm, config);
      const refillCheck = getNextRefillCheck(refillType);
      dispatchServiceData({
        type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_ON,
        refill_type: refillType,
        refill_check: refillCheck,
        refill_days: providerRefillDays || defaultRefillDays,
      })
    } else {
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_OFF })
    }
  };

  return (
    <>
      <FormSwitch id="refill" name="refill" checked={selectedValue} onChange={onChange}>
        Refill
      </FormSwitch>
    </>
  );
};

FieldRefillSwitch.propTypes = {
  form: PropTypes.object,
  providerForm: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  dispatchServiceData: PropTypes.func,
}

export default FieldRefillSwitch;
